function toggleAnnouncementTranslation(element, option) {
    let bodyClass = document.querySelector(
        ".shopify-section-header-sticky.announce-top"
    );

    element.style.top = 0;

    if (bodyClass && option) {
        let announcementBarHeight = document.querySelector(
            ".announcement-bar.top"
        ).offsetHeight;
        element.style.top = -announcementBarHeight + "px";
    }
}

function initGsapDualSticky(section) {
    if (section.getAttribute("initialized") == 1) {
        return;
    }

    section.setAttribute("initialized", 1);
    let left = section.querySelector(".left");

    let right = section.querySelector(".right");
    let headerHeight = document.querySelector("sticky-header").offsetHeight;
    let topSpace = headerHeight;

    let pinElement = left.querySelector(".inner");

    if (right.offsetHeight > window.innerHeight && window.innerWidth > 740) {
        if (document.body.classList.contains("announce-top")) {
            if (!section.classList.contains("visual")) {
                topSpace += document.querySelector(
                    ".announcement-bar.top"
                ).offsetHeight;
            }
        }

        setTimeout(function () {
            gsap.timeline({
                scrollTrigger: {
                    pin: true,
                    pinSpacing: false,
                    trigger: left,
                    start: "top " + topSpace + "px",
                    end: () =>
                        `$+=${
                            right.offsetHeight -
                            window.innerHeight -
                            headerHeight
                        }`,
                    invalidateOnRefresh: true,
                    scrub: true,
                    onEnter: () => {
                        toggleAnnouncementTranslation(pinElement, true);
                    },
                    onEnterBack: () => {
                        toggleAnnouncementTranslation(pinElement, true);
                    },
                    onLeave: () => {
                        toggleAnnouncementTranslation(pinElement, false);
                    },
                    onLeaveBack: () => {
                        toggleAnnouncementTranslation(pinElement, false);
                    },
                },
            });
        }, 20);
    }
}
